document.addEventListener('DOMContentLoaded', () => {
  const btnMobileNav = document.querySelector('.mobile-menu-toggle');

  const mobileNav = document.querySelector('#mobile-nav');
  if (btnMobileNav && mobileNav) {
    btnMobileNav.addEventListener('click', function () {
      window.requestAnimationFrame(() => {
        btnMobileNav.classList.toggle('mobile-menu-toggle-clicked');
        mobileNav.classList.toggle('show-mobile-nav');
      });
    });

    window.addEventListener('resize', () => {
      const w =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      if (w > 1200) {
        window.requestAnimationFrame(() => {
          btnMobileNav.classList.remove('mobile-menu-toggle-clicked');
          mobileNav.classList.remove('show-mobile-nav');
        });
      }
    });
  }
});
